import {useEffect, useState} from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import {styled} from '@mui/material/styles'
import PropTypes from 'prop-types'
const StyledDiv = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
  height: '300px',
  [theme.breakpoints.up('xl')]: {
    height: '400px'
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    height: '500px'
  }
}))
export default function ChartLoadingIndicator({isLoading, onLoadComplete}) {
  const [progress, setProgress] = useState(0)
  useEffect(() => {
    let timer
    if (isLoading) {
      timer = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress === 70) return 70
          return prevProgress + 1
        })
      }, 50)
    }

    return () => {
      clearInterval(timer)
    }
  }, [isLoading])
  useEffect(() => {
    let timer
    if (!isLoading) {
      setProgress(100)
      timer = setTimeout(function () {
        onLoadComplete()
      }, 500)
    }
    return () => {
      clearInterval(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])
  return (
    <StyledDiv data-testid='timeseries-chart-loading' aria-label='chart is loading'>
      <CircularProgress
        size={'2rem'}
        variant='determinate'
        value={progress}
        data-testid='timeseries-circular-progress'
      />
    </StyledDiv>
  )
}

ChartLoadingIndicator.propTypes = {
  onLoadComplete: PropTypes.func,
  isLoading: PropTypes.bool
}
